export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7332.c10a4832.jpg";